module.exports = __webpack_public_path__ + "img/M.bafb0d76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/M.jpg
// module id = /f6b
// module chunks = 1